module.exports = __webpack_public_path__ + "media/images/meat2-12efebf3796d0bb95ca4a4f16491cb8c.jpg";